<template>
    <v-flex>
        <v-layout v-if="isNetworkPage">
            <v-card class="panelBlock network-member_non">
                <v-flex tag="h4">{{NoNetworkAffiliatedConstants.Headings.NOT_JOINED}}</v-flex>
                <strong>{{NoNetworkAffiliatedConstants.Description.READ_ABOUT}}</strong>

                <h6>{{NoNetworkAffiliatedConstants.Network_Type.BUSINESS}}</h6>

                <p v-html="NoNetworkAffiliatedConstants.Description.BUSINESS"></p>

                <h6>{{NoNetworkAffiliatedConstants.Network_Type.PERSONAL}}</h6>

                <p v-html="NoNetworkAffiliatedConstants.Description.PERSONAL"></p>

                <h6>{{NoNetworkAffiliatedConstants.Network_Type.SOCIAL}}</h6>

                <p v-html="NoNetworkAffiliatedConstants.Description.SOCIAL"></p>

                <h6>{{NoNetworkAffiliatedConstants.Network_Type.FAMILY}}</h6>
                <p v-html="NoNetworkAffiliatedConstants.Description.FAMILY"></p>
            </v-card>
        </v-layout>
        <non-member-message v-else-if="isGroupPage"></non-member-message>
        <v-flex v-else>
            {{communityCommonConstant.YOU_HAVENOT_JOINED_ANY}} {{$route.name.charAt(0).toUpperCase()}}{{$route.name.toLowerCase().slice(1)}}{{`s`}} {{communityCommonConstant.YET}}
        </v-flex>
    </v-flex>
</template>

<script>
    import { NoNetworkAffiliatedConstants } from './NetworkConstants';
    import { communityCommonConstant } from "../ChapterPage/communityCommon.constant";
    import { routerNames } from "../appCommon.constants";
    import NonMemberMessage from "../ChapterPage/NonMemberMessage/NonMemberMessage.vue";

    export default {
        name: 'NocommunityAffiliation',
        data: () => {
            return {
                NoNetworkAffiliatedConstants,
                communityCommonConstant,
                routerNames,
            };
        },
        components: {
            NonMemberMessage,
        },
        computed: {
            isNetworkPage() {
                return this.$route.name === this.routerNames.NETWORK;
            },
            isGroupPage() {
                return this.$route.name === this.routerNames.GROUP;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';

    .network-member_non {
        padding: 20px;

        h4 {
            color: $ypo_blue;
            font-family: Raleway;
            font-size: 22px;
            font-weight: 500;
            line-height: 26px;
            text-align: center;
            margin: 10px 0 40px 0;
        }

        h6 {
            color: $ypo_blue;
            font-size: 14px;
            font-weight: 600;
            margin: 30px 0 10px 0;
        }
    }
</style>
